/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteCheckoutFullfillmentStocking200Response
 */
export interface DeleteCheckoutFullfillmentStocking200Response {
    /**
     * 
     * @type {object}
     * @memberof DeleteCheckoutFullfillmentStocking200Response
     */
    data: object;
    /**
     * 
     * @type {object}
     * @memberof DeleteCheckoutFullfillmentStocking200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the DeleteCheckoutFullfillmentStocking200Response interface.
 */
export function instanceOfDeleteCheckoutFullfillmentStocking200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function DeleteCheckoutFullfillmentStocking200ResponseFromJSON(json: any): DeleteCheckoutFullfillmentStocking200Response {
    return DeleteCheckoutFullfillmentStocking200ResponseFromJSONTyped(json, false);
}

export function DeleteCheckoutFullfillmentStocking200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCheckoutFullfillmentStocking200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
        'meta': json['meta'],
    };
}

export function DeleteCheckoutFullfillmentStocking200ResponseToJSON(value?: DeleteCheckoutFullfillmentStocking200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'meta': value.meta,
    };
}

